var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgRadioButtonNotSelected(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_27_8216)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M25 49.9991C11.215 49.9991 0 38.7839 0 24.9991C0 11.2113 11.215 -0.00390625 25 -0.00390625C28.2833 -0.00390627 31.5344 0.642838 34.5678 1.89939C37.6011 3.15595 40.3572 4.99771 42.6787 7.31949C45.0002 9.64128 46.8417 12.3976 48.0979 15.4311C49.354 18.4646 50.0004 21.7158 50 24.9991C50 38.7839 38.7852 49.9991 25 49.9991ZM25 10.5216C17.0225 10.5216 10.532 17.0157 10.532 24.9991C10.532 32.9765 17.0225 39.4675 25 39.4675C32.9827 39.4675 39.4771 32.9764 39.4771 24.9991C39.4772 17.0157 32.9828 10.5216 25 10.5216Z",
    fill: "#F9F9F9"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_27_8216"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 50,
    height: 50,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRadioButtonNotSelected);
export default __webpack_public_path__ + "static/media/radio_button_not_selected.85bf740bf2b091b40b35fe4deb7c530c.svg";
export { ForwardRef as ReactComponent };